import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

 
export const getSurveyCategoryList = async (params={})=>{

    const url =`${API_ENDPOINTS.SURVEY.GET_SURVEY_CATEGORY_LIIST}` 
    let response = await axiosInstance.get(url,{params});
    const rowData  = response?.data;
     const formatedData = Array.isArray(rowData?.data?.data)?
     rowData.data.data.map((item:any)=>({
      SurveyCatName:item.SurveyCatName ||'-',
      Orgunitid:item.Orgunitid ||'-',
      SurveyCatid:item.SurveyCatid || '-',
      SurveyFor:item.SurveyFor|| '-',
      Status:item.Status || null,
      IsForDcr:item.IsForDcr|| null,
     })):[]
     return {rowData,formatedData}
}


export const AddSurveyCategory  =async (ReqBody:any)=>{
  const url  = `${API_ENDPOINTS.SURVEY.POST_ADD_SURVEY_CATEGORY}`
  let response = await axiosInstance.post(url,ReqBody);
}

export const UpdateSurveyCategory= async (ReqBody:any,id:number)=>{
 const url = `${API_ENDPOINTS.SURVEY.PUT_UPDATE_SURVEY_CATEGORY}/${id}`;
 let response = await axiosInstance.put(url,ReqBody); 
}